import Yup from 'src/yup';

export const validationSchema = Yup.object().shape({
  chargerGroupName: Yup.string()
    .trim()
    .required('You must enter a charger group name')
    .max(250, 'Name may only contain a maximum of 250 characters'),
  description: Yup.string().trim().nullable().max(200, 'Description may only contain a maximum of 200 characters'),
});
